import type { FC } from 'react';
import {
  Card,
  Table,
  TableHead,
  TableRow,
  Box,
  TableBody,
  TableCell,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import Title from 'src/components/admin/Title';
import Scrollbar from 'src/components/admin/Scrollbar';
import { numberToMillons } from 'src/utils/functions';
import TableCellHeaderSum from 'src/components/global/TableCellHeaderSum';

interface PropsSeguimientoTerritorioConvenio {
  content: {
    data: any;
    resume: { operaciones: number; facturacion: number; meta: number };
    pages: { total: number; current: number; limit: number };
  };
  handleChangePage: (event: unknown, page: number) => Promise<void>;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => Promise<void>;
}

const SeguimientoTerritorioConvenio: FC<PropsSeguimientoTerritorioConvenio> = ({
  content,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const title = 'Facturación por Convenios, En unidades, MM de PEN';
  const headers = [
    'Convenio',
    'Operaciones',
    'Facturación',
  ];

  return (
    <Box pt={2}>
      <Title title={title} />
      <Card>
        <Scrollbar>
          <Table size="small" className="zoomin">
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCellHeaderSum
                    key={header}
                    align={index !== 0 ? 'right' : 'left'}
                  >
                    {header}
                  </TableCellHeaderSum>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {content.data.map((item) => (
                <TableRow key={item.label}>
                  <TableCell>{item.label}</TableCell>
                  <TableCell align="right">{item.operaciones}</TableCell>
                  <TableCell align="right">
                    {numberToMillons(item.facturacion)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableHead>
              <TableRow>
                <TableCellHeaderSum>Total</TableCellHeaderSum>
                <TableCellHeaderSum align="right">
                  {content.resume.operaciones}
                </TableCellHeaderSum>
                <TableCellHeaderSum align="right">
                  {numberToMillons(content.resume.facturacion)}
                </TableCellHeaderSum>
              </TableRow>
            </TableHead>
            <TableFooter>
              <TableRow>
                <TablePagination
                  backIconButtonProps={{
                    title: 'Página anterior',
                  }}
                  nextIconButtonProps={{
                    title: 'Página siguiente',
                  }}
                  rowsPerPageOptions={[5, 10, 15, 20]}
                  labelRowsPerPage="Registros por página"
                  labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                  count={content.pages.total}
                  page={content.pages.current}
                  rowsPerPage={content.pages.limit}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </Scrollbar>
      </Card>
    </Box>
  );
};

export default SeguimientoTerritorioConvenio;
